import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RequirePermission } from "@/components/universal/require-permission";
import NotFoundPage from "@/catchall";

export const Route = createFileRoute("/_private/_stock-360")({
  component: StockLayout,
});

function StockLayout() {
  return (
    <RequirePermission permission="stock_360" fallback={<NotFoundPage />}>
      <Outlet />
    </RequirePermission>
  );
}
